import SafeImage from './SafeImage';
import SafeNextImage from './SafeNextImage';

export {SafeImage, SafeNextImage};
export default SafeImage;
